export default __webpack_public_path__ + "static/22-d695d3b2237918b49bffb8c8a71e7fea.jpg";